'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var loginSeries = require('./loginSeries');
var cashier = require('./cashier');

module.exports = [function (config) {
    var sniff = this.sniff,
        space = void 0;

    config.hytiveReg = "(^|\\s)(qunar[^\\/]+)\\/([\\d\\.]+)";
    config.wechatSupport = true;
    config.wechatSignatureUrl = '//ccweixin.qunar.com/chat/getJsConfig.do';
    config.ucAPIScriptUrl = '//common.qunarzz.com/ucapi/prd/scripts/1.0.3/api@d20c312aba29a7178996dd57abcca695.js';

    var _ref = navigator.userAgent.toLowerCase().match(config.hytiveReg) || [];

    var _ref2 = _slicedToArray(_ref, 4);

    sniff.qunar = _ref2[0];
    space = _ref2[1];
    sniff.scheme = _ref2[2];
    sniff.appVersion = _ref2[3];

    sniff.qunar = !!sniff.qunar;
}, loginSeries, cashier];

/**
 * 向后端发送数据<br />
 * 对应native接口：hy.uelog
 * @method hysdk.uelog
 * @category Qunar
 * @example ./uelog.js[1-11]
 * @description
 *
 * | 运行环境 | 是否支持 |
 * | :-----: | :-----: |
 * | Hy      |   √   |
 * | Hy Browser (qunar) | √    |
 * | Hy Browser (非qunar) | X    |
 * | touch   |   X  |
 * | wechat  |   X   |
 * | ctrip   |   X   |
 *
 */

/**
* 获取abTest的策略信息<br />
* 对应native接口：abTest.getCase
* @method hysdk.abTest
* @category Qunar
* @example ./abTest.js[1-12]
* @description
*
* | 运行环境 | 是否支持 |
* | :-----: | :-----: |
* | Hy      |   √   |
* | Hy Browser (qunar) | √    |
* | Hy Browser (非qunar) | X    |
* | touch   |   X  |
* | wechat  |   X   |
* | ctrip   |   X   |
*
*/


//////////////////
// WEBPACK FOOTER
// ../plugins/qunar/index.js
// module id = 33
// module chunks = 1 3 4